// @flow
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import moment from "moment";
import {isEqual} from "lodash";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    FastForwardOutlined,
    LoadingOutlined,
    UndoOutlined,
    ArrowsAltOutlined,
    ShrinkOutlined,
    DoubleRightOutlined,
    CommentOutlined,
    FileTextOutlined,
    CloseOutlined
} from "@ant-design/icons";
import {
    Avatar,
    Col,
    List,
    Popover,
    Row,
    Skeleton,
    Spin,
    Table,
    Collapse,
    Typography,
    Image,
    Tooltip,
    Button
} from "antd";
import L from "leaflet";
import ReactDOMServer from "react-dom/server";
import {CountdownButton} from "./countdownButton/CountdownButton";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {useCodPaymentBrandLabel} from "../../../hooks/useCodPaymentBrandLabel";
import useIsFocused from "../../../hooks/useIsFocused";
import {
    AnnulmentButton,
    DescriptionContainer,
    DetailTag,
    FileImageFilledIcon,
    LeftButton,
    MapContainer,
    MapLegend,
    MapTools,
    MiddleButton,
    MinusCircleFilledIcon,
    OrderNumber,
    OrderTableCustom,
    PickupTableCustom,
    ReturnTableCustom,
    OrderTotalTime,
    MergedOrderStats,
    RightButton,
    SpinnerContainer,
    StepContainer,
    TableTitle,
    TransferDescription,
    TransferInfoContainer,
    TransferLogList,
    PassButton,
    MarkerIcon,
    CourierMarkerIcon,
    MarkerPopupContainer,
    MarkerPopupLabel,
    MapDiv,
    TableOverflowWithBorder,
    OrderDetailContainer,
    OrderDetailTitle,
    OrderDetailContent,
    OrderDetailRow,
    OrderDetailLabel,
    OrderDetailValue,
    ProductTableContainer
} from "./OrderDetail.style";
import {CourierIcon} from "../../_defaultComponents/CourierIcon/CourierIcon";
import {TileLayerControl} from "../../_defaultComponents/TileLayerControl/TileLayerControl";
import {
    averageGeolocation,
    configureLeafletMarkerIcons,
    decodePolyline,
    formatPhoneNumber,
    calculateElapsedTime,
    getReadableTextColor,
    attachMarkerPopupInteractions,
    addTileLayerWithFallback,
    TURKEY_BOUNDS,
    TILE_LAYER_TYPES
} from "../../../utils/helpers";
import {
    courierStatusColors,
    orderTableColors,
    pickupColor,
    receiverColor,
    canceledColor,
    deliveredColor,
    defaultSlotCourierIds,
    mapDeliveryStatuses,
    returnedColor
} from "../../../constants/constants";
import {TextBoxFormModal} from "../../_defaultComponents/TextBoxFormModal/TextBoxFormModal";
import config from "../../../_core/config";
import placeholder from "../../../public/images/person-placeholder.jpg";
import {ProofModal} from "./proof/ProofModal";
import {OrderNoteModal} from "./orderNote/OrderNoteModal";
import ProductTable from "../../_defaultComponents/ProductTable";
import OrderSteps from "./Steps/OrderSteps";
import SlotDetailCard from "./slot/SlotDetailCard";
import {PlatformDeliveryDetailTable} from "./platformDeliveryDetailTable/PlatformDeliveryDetailTable";
import {ReceiptPrinter} from "../../_defaultComponents/ReceiptPrinter/ReceiptPrinter";
import {NextStepModal} from "./nextStepModal/NextStepModal";

const {Column} = Table;
const {Text} = Typography;
const initialText = {
    label: "",
    title: ""
};

export const OrderDetail = ({deliveryId}) => {
    const stores = useStore();
    const codPaymentBrandLabel = useCodPaymentBrandLabel();
    const history = useHistory();
    const isFocused = useIsFocused();
    const {t, i18n} = useTranslation(["orderDetail", "deliveryStatuses", "paymentTypes"]);
    const [orderSteps, setOrderSteps] = useState([]);
    const [pickupSteps, setPickupSteps] = useState([]);
    const [returnSteps, setReturnSteps] = useState([]);
    const [allSteps, setAllSteps] = useState([]);
    const [canceled, setCanceled] = useState(false);
    const [returned, setReturned] = useState(false);
    const [delivered, setDelivered] = useState(false);
    const [inQueue, setInQueue] = useState(false);
    const [inPrep, setInPrep] = useState(false);
    const [assignedCourierId, setAssignedCourierId] = useState();
    const [recall, setRecall] = useState(true);
    const [transferLogRecall, setTransferLogRecall] = useState(true);
    const [loading, setLoading] = useState(false);
    const [colorIndexList, setColorIndexList] = useState({});
    const [hover, setHover] = useState("");
    const [modalType, setModalType] = useState("");
    const [text, setText] = useState(initialText);
    const [modalVisible, setModalVisible] = useState(false);
    const [submit, setSubmit] = useState();
    const [deliveryType, setDeliveryType] = useState();
    const [modalData, setModalData] = useState({deliveryId: "", orderId: ""});
    const [center, setCenter] = useState({
        lat: 41.11,
        lng: 29.11
    });
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markersRef = useRef([]);
    const polylinesRef = useRef([]);
    const tileLayerRef = useRef(null);
    const [mapMode, setMapMode] = useState("relative");
    const [userHasInteracted, setUserHasInteracted] = useState(false);
    const [totalTime, setTotalTime] = useState("");
    const [deliveredTime, setDeliveredTime] = useState("");
    const [latestLocationId, setLatestLocationId] = useState(null);
    const [exactPath, setExactPath] = useState([]);
    const [proofVisible, setProofVisible] = useState();
    const [proofData, setProofData] = useState({proof: {}, step: {}});
    const recallRef = useRef(recall);
    const transferLogRecallRef = useRef(transferLogRecall);
    const [isReceiptPrinting, setIsReceiptPrinting] = useState(false);
    const receiptRef = useRef();
    const [receiptModalVisible, setReceiptModalVisible] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [hideOrderError, setHideOrderError] = useState(false);
    const [orderNoteModalVisible, setOrderNoteModalVisible] = useState(false);
    const [operationNotes, setOperationNotes] = useState([]);
    recallRef.current = recall;
    transferLogRecallRef.current = transferLogRecall;
    const [isOpenNextStepModal, setIsOpenNextStepModal] = useState(false);
    const [nextStepData, setNextStepData] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [activeMobileTab, setActiveMobileTab] = useState("siparis");

    const [orderLoading, orderData, setOrderData, setOrderLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.orderStore.getOrder.bind(null, {
            deliveryId,
            hideError: hideOrderError
        }),
        dependencies: [recall]
    });

    const [transferLoading, transferData, setTransferData, setTransferLoading] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.orderStore.getTransferLogs.bind(null, {
            deliveryId
        }),
        dependencies: [transferLogRecall]
    });

    const [
        deliveryLocationsDataLoading,
        deliveryLocationsData,
        setDeliveryLocationsData,
        setDeliveryLocationsDataLoading
    ] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.courierStore.getDeliveryLocations.bind(null, {
            deliveryId,
            ...(latestLocationId !== null && {latestLocationId: latestLocationId})
        }),
        dependencies: [recall]
    });

    const orderNumber = orderData?.data?.delivery?.orders.map(x => x.orderNumber).join(", ");

    const estimation = orderData?.data?.estimation;

    useEffect(() => {
        if (orderData.status === 400) {
            history.push("/orders");
        } else if (isFocused) {
            let timeout = null;
            if (
                orderData?.data?.delivery?.deliveryState !== "delivered" &&
                orderData?.data?.delivery?.deliveryState !== "canceled" &&
                orderData?.data?.delivery?.deliveryState !== "rejected" &&
                orderData?.data?.delivery?.deliveryState !== "returned"
            ) {
                timeout = setTimeout(() => {
                    setRecall(!recallRef.current);
                }, 2000);
            }
            if (deliveryLocationsData.length > 0) {
                setLatestLocationId(deliveryLocationsData.slice(-1).pop().id);
            }

            return () => clearTimeout(timeout);
        }
    }, [recall, isFocused]);

    useEffect(() => {
        if (assignedCourierId) {
            setTransferLogRecall(!transferLogRecallRef.current);
        }
    }, [assignedCourierId]);

    useEffect(() => {
        setDeliveryType(orderData?.data?.delivery?.deliveryType);
        setTotalTime(orderData?.data?.delivery?.createdAt);
        if (orderData.status !== 200) {
            return;
        }

        if (
            orderData?.data?.delivery?.deliveryState === "canceled" ||
            orderData?.data?.delivery?.deliveryState === "rejected" ||
            orderData?.data?.delivery?.deliveryState === "returned"
        ) {
            const newSteps = orderData?.data?.steps.slice(
                0,
                orderData?.data?.delivery.currentStepIndex
            );
            setAllSteps(newSteps);
        } else {
            setAllSteps(orderData?.data?.steps);
        }

        let orderSteps = [];
        let pickupSteps = [];
        let returnSteps = [];
        let colorIndex = {};
        let index = 0;

        orderData.data.steps
            .sort((prev, curr) => prev.stepIndex - curr.stepIndex)
            .forEach(step => {
                if (step.deliveryState === "onDeliveryAddress") {
                    colorIndex[step.stepInfo._id] = orderTableColors[index];
                    orderSteps.push(step);
                }
                if (step.deliveryState === "onPickUpAddress") {
                    const products = [];
                    step?.stepInfo?.orders?.forEach(order => {
                        products.push(...order.products);
                    });
                    pickupSteps.push({...step, products});
                }
                if (step.deliveryState === "onReturnAddress") {
                    returnSteps.unshift(step);
                }
            });

        setDeliveredTime(orderData?.data?.steps[orderData?.data?.steps.length - 1]?.endDate);
        setColorIndexList(colorIndex);
        setOrderSteps(orderSteps);
        setPickupSteps(pickupSteps);
        setReturnSteps(returnSteps);

        const coordinates = orderSteps
            .map(step => ({
                latitude: step.stepInfo.receiverLocation.lat,
                longitude: step.stepInfo.receiverLocation.lon
            }))
            .concat(pickupSteps.map(step => step.stepInfo.location));

        const centerOfMap = averageGeolocation(coordinates);

        if (!isNaN(centerOfMap?.lat) && !isNaN(centerOfMap.lng)) setCenter(centerOfMap);
        setCanceled(orderData?.data?.delivery?.deliveryState === "canceled");
        setReturned(orderData?.data?.delivery?.deliveryState === "returned");
        setDelivered(orderData?.data?.delivery?.deliveryState === "delivered");
        setInQueue(orderData?.data?.delivery?.deliveryState === "inQueue");
        setInPrep(orderData?.data?.delivery?.deliveryState === "inPrep");
        setAssignedCourierId(orderData.data?.delivery?.assignedCourier?._id);
    }, [orderData]);

    useEffect(() => {
        if (modalType === "cancel") {
            setText({
                label: t("deliveryModal.cancelReasonLabel", {ns: "common"}),
                title: t("deliveryModal.cancelReasonTitle", {ns: "common"})
            });
            setSubmit(() => cancelDelivery);
        } else if (modalType === "splitOrder") {
            setText({
                label: t("modal.splitOrder.label", {ns: "orderDetail"}),
                title: t("modal.splitOrder.title", {ns: "orderDetail"})
            });
            setSubmit(() => splitOrder);
        } else if (modalType === "pass") {
            setText({
                label: t("modal.passOrder.label", {ns: "orderDetail"}),
                title: t("modal.passOrder.title", {ns: "orderDetail"})
            });
            setSubmit(() => passOrder);
        } else if (modalType === "cancelOrder") {
            setText({
                label: t("modal.cancelOrder.label", {ns: "orderDetail"}),
                title: t("modal.cancelOrder.title", {ns: "orderDetail"})
            });
            setSubmit(() => cancelOrder);
        } else if (modalType === "cancelOrderByNumber") {
            setText({
                label: t("modal.cancelOrder.label", {ns: "orderDetail"}),
                title: t("modal.cancelOrder.title", {ns: "orderDetail"})
            });
            setSubmit(() => cancelOrderByNumber);
        } else if (modalType !== "transfer") {
            setModalVisible(false);
        }
    }, [modalType]);

    useEffect(() => {
        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, [mapMode]);

    useEffect(() => {
        if (mapInstanceRef.current) {
            setTimeout(() => {
                if (mapInstanceRef.current) {
                    mapInstanceRef.current.invalidateSize();
                }
            }, 300);
        }
    }, [mapMode]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Leaflet map initialization
    useEffect(() => {
        const initializeMap = () => {
            if (mapRef.current && !mapInstanceRef.current) {
                // Configure Leaflet marker icons using helper function
                configureLeafletMarkerIcons(L);

                try {
                    // Türkiye sınırları
                    const turkeyBounds = L.latLngBounds(
                        TURKEY_BOUNDS.southWest,
                        TURKEY_BOUNDS.northEast
                    );

                    mapInstanceRef.current = L.map(mapRef.current, {
                        maxBounds: turkeyBounds,
                        maxBoundsViscosity: 1.0,
                        minZoom: 7,
                        maxZoom: 22
                    }).setView([center.lat, center.lng], 13);

                    // Add tile layer with fallback
                    tileLayerRef.current = addTileLayerWithFallback(
                        L,
                        mapInstanceRef.current,
                        TILE_LAYER_TYPES.BASIC
                    );

                    // Add event listeners to track user interaction
                    mapInstanceRef.current.on("zoomend", () => {
                        setUserHasInteracted(true);
                    });
                    mapInstanceRef.current.on("moveend", () => {
                        setUserHasInteracted(true);
                    });

                    // Ensure map controls have proper z-index
                    const mapContainer = mapInstanceRef.current.getContainer();
                    if (mapContainer) {
                        const controls = mapContainer.querySelectorAll(".leaflet-control");
                        controls.forEach(control => {
                            control.style.zIndex = "1000";
                        });
                    }

                    // Force map to invalidate size
                    setTimeout(() => {
                        if (mapInstanceRef.current) {
                            mapInstanceRef.current.invalidateSize();
                            // Render polylines after map is ready
                            renderPolylines();
                            renderPolylinesExact();
                        }
                    }, 100);
                } catch (error) {
                    console.error("Error initializing Leaflet map:", error);
                }
            }
        };

        // Wait for mapRef to be ready with retry mechanism
        const waitForMapRef = (retryCount = 0) => {
            if (mapRef.current) {
                initializeMap();
            } else if (retryCount < 20) {
                setTimeout(() => waitForMapRef(retryCount + 1), 200);
            }
        };

        const timer = setTimeout(() => waitForMapRef(), 100);

        return () => {
            clearTimeout(timer);
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
            }
        };
    }, []); // Run only once on mount

    // Update map center when center changes (only if user hasn't interacted)
    useEffect(() => {
        if (mapInstanceRef.current && !userHasInteracted) {
            mapInstanceRef.current.setView(
                [center.lat, center.lng],
                mapInstanceRef.current.getZoom()
            );
        }
    }, [center, userHasInteracted]);

    const courierIconBackgroundColor = useMemo(() => {
        let colorStatueName = orderData.data?.courierLocation?.status;
        if (colorStatueName === "busy") {
            colorStatueName = orderData.data.delivery.deliveryState;
        }
        return courierStatusColors[colorStatueName];
    }, [orderData?.data?.courierLocation?.status, orderData?.data?.delivery?.deliveryState]);

    const handleEsc = event => {
        if (event.keyCode === 27 && mapMode == "fixed") {
            setMapMode("relative");
        }
    };

    const getOperationNoteAndModal = async ({orderId, modalVisible}) => {
        const res = await stores.orderStore.getOperationNotes({
            orderId
        });
        setOperationNotes(res.data);
        setOrderNoteModalVisible(modalVisible);
    };

    const reOrder = ({deliveryId, orderId}) => {
        stores.appStore.openConfirmModal({
            title: t("modal.confirmTitle", {ns: "common"}),
            content: t("modal.reOrder.content", {ns: "orderDetail"}),
            onOk: async () => {
                await setOrderLoading(true);
                await stores.orderStore.reOrder({
                    deliveryId,
                    orderId
                });
                setRecall(!recallRef.current);
                await setOrderLoading(false);
            }
        });
    };

    const passOrder = ({deliveryId, orderId, reason}) => {
        stores.appStore.openConfirmModal({
            title: t("modal.confirmTitle", {ns: "common"}),
            content: t("modal.passOrder.content", {ns: "orderDetail"}),
            onOk: async () => {
                await setOrderLoading(true);
                await stores.orderStore.passOrder({
                    deliveryId,
                    orderId,
                    reason
                });
                setRecall(!recallRef.current);
                await setOrderLoading(false);
                setModalVisible(false);
            }
        });
    };

    const cancelOrder = ({deliveryId, orderId, reason, shouldRefundFee, shouldSendCallback}) => {
        stores.appStore.openConfirmModal({
            title: t("modal.confirmTitle", {ns: "common"}),
            content: t("deliveryModal.cancelConfirmContent", {ns: "common"}),
            onOk: async () => {
                await setOrderLoading(true);
                await stores.orderStore.cancelOrder({
                    deliveryId,
                    orderId,
                    reason,
                    shouldRefundFee,
                    shouldSendCallback
                });
                setRecall(!recallRef.current);
                await setOrderLoading(false);
                setModalVisible(false);
            }
        });
    };
    const cancelOrderByNumber = ({
        orderNumber,
        reason,
        resend = false,
        triggerInMinutes,
        forceCourierId,
        shouldRefundFee,
        shouldSendCallback
    }) => {
        stores.appStore.openConfirmModal({
            title: t("modal.confirmTitle", {ns: "common"}),
            content: t("modal.cancelOrder.content", {ns: "orderDetail"}),
            onOk: async () => {
                await setOrderLoading(true);
                const response = await stores.orderStore.cancelOrderByNumber({
                    vigoOrderNumber: modalData.vigoOrderNumber,
                    cancelText: reason.label,
                    cancelKey: reason.value,
                    resend,
                    triggerInMinutes,
                    forceCourierId,
                    shouldRefundFee,
                    shouldSendCallback
                });
                setRecall(!recallRef.current);
                await setOrderLoading(false);
                setModalVisible(false);
            }
        });
    };

    const splitOrder = async ({
        deliveryId,
        orderIds,
        allowMerge,
        forceCourierId,
        reason,
        triggerInMinutes
    }) => {
        stores.appStore.openConfirmModal({
            title: t("modal.confirmTitle", {ns: "common"}),
            content: t("modal.splitOrder.content", {ns: "orderDetail"}),
            onOk: async () => {
                await setOrderLoading(true);
                await stores.orderStore.splitOrder({
                    deliveryId,
                    orderIds,
                    allowMerge,
                    forceCourierId,
                    reason,
                    triggerInMinutes
                });
                const ordersCount = orderData?.data?.delivery?.orders?.length || 0;

                if (ordersCount == 0 || ordersCount == orderIds.length) {
                    history.push("/orders");
                } else {
                    setRecall(!recallRef.current);
                }
                await setOrderLoading(false);
                setModalVisible(false);
            },
            onCancel: () => {
                setHideOrderError(false);
            }
        });
    };

    const updateStep = async () => {
        const currentStep =
            allSteps[
                orderData.data?.steps?.slice(-1)[0]?.endDate && delivered
                    ? orderData.data.delivery.currentStepIndex
                    : orderData.data.delivery.currentStepIndex - 1
            ];

        if (
            currentStep.deliveryState === "onDeliveryAddress" &&
            Boolean(currentStep.startDate) &&
            Boolean(currentStep.trial)
        ) {
            if (currentStep.trial.startDate) {
                await stores.orderStore.trialEnd({courierId: assignedCourierId});
                await stores.orderStore.updateStep({
                    deliveryId,
                    courierId: orderData.data?.delivery?.assignedCourier?._id,
                    currentDeliveryState: orderData.data?.delivery?.deliveryState
                });
            } else {
                await stores.orderStore.trialStart({courierId: assignedCourierId});
            }
        } else {
            const updatedStepData = await stores.orderStore.updateStep({
                deliveryId,
                courierId: orderData.data?.delivery?.assignedCourier?._id,
                currentDeliveryState: orderData.data?.delivery?.deliveryState
            });
            if (updatedStepData?.data?.vigoPayment) {
                setNextStepData(updatedStepData);
                setIsOpenNextStepModal(true);
            }
        }

        setRecall(!recallRef.current);
        setLoading(false);
    };
    const triggerCallback = useCallback(async () => {
        await stores.orderStore.triggerCallback({
            deliveryId
        });
    }, [deliveryId, stores.orderStore]);

    const cancelDelivery = ({reason, shouldRefundFee, shouldSendCallback}) => {
        stores.appStore.openConfirmModal({
            title: t("modal.confirmTitle", {ns: "common"}),
            content: t("deliveryModal.cancelConfirmContent", {ns: "common"}),
            onOk: async () => {
                await setOrderLoading(true);
                stores.orderStore.cancelDelivery({
                    cancelText: reason.label,
                    cancelKey: reason.value,
                    deliveryId,
                    shouldRefundFee,
                    shouldSendCallback
                });
                setRecall(!recallRef.current);
                setModalVisible(false);
                await setOrderLoading(false);
            }
        });
    };

    const fitBounds = ({map, pickupSteps, orderSteps, courierLocation, estimationRoutes}) => {
        if (!map) return;

        const bounds = [];

        if (pickupSteps) {
            pickupSteps.forEach(pickup => {
                if (pickup?.stepInfo?.location?.latitude && pickup?.stepInfo?.location?.longitude) {
                    bounds.push([
                        pickup.stepInfo.location.latitude,
                        pickup.stepInfo.location.longitude
                    ]);
                }
            });
        }

        if (orderSteps) {
            orderSteps.forEach(order => {
                if (
                    order?.stepInfo?.receiverLocation?.lat &&
                    order?.stepInfo?.receiverLocation?.lng
                ) {
                    bounds.push([
                        order.stepInfo.receiverLocation.lat,
                        order.stepInfo.receiverLocation.lng
                    ]);
                }
            });
        }

        if (
            courierLocation &&
            !["delivered", "canceled", "returned"].includes(
                orderData?.data?.delivery?.deliveryState
            )
        ) {
            bounds.push([courierLocation.coordinates[1], courierLocation.coordinates[0]]);
        }

        if (estimationRoutes) {
            estimationRoutes
                .filter(r => !!r.encodedPolylines)
                .forEach(route => {
                    const path = decodePolyline(route.encodedPolylines);
                    path.forEach(coordinate => {
                        if (coordinate.lat && coordinate.lng) {
                            bounds.push([coordinate.lat, coordinate.lng]);
                        }
                    });
                });
        }

        if (bounds.length === 0) return;

        const boundsGroup = L.latLngBounds(bounds);
        map.fitBounds(boundsGroup);
    };

    useEffect(() => {
        if (mapInstanceRef.current) {
            renderPolylines();
        }
    }, [estimation?.routes.length, mapInstanceRef.current]);

    useEffect(() => {
        if (mapInstanceRef.current) {
            renderPolylinesExact();
        }
    }, [deliveryLocationsData, mapInstanceRef.current]);

    // Render markers when order data changes
    useEffect(() => {
        if (mapInstanceRef.current && orderSteps.length > 0) {
            renderReceiverMarkers(orderSteps);
        }
    }, [orderSteps, orderData]);

    // Render pickup markers
    useEffect(() => {
        if (mapInstanceRef.current && pickupSteps.length > 0) {
            renderPickupMarkers(pickupSteps);
        }
    }, [pickupSteps]);

    // Render courier marker
    useEffect(() => {
        if (mapInstanceRef.current && orderData?.data?.courierLocation) {
            renderCourierMarker();
        }
    }, [orderData?.data?.courierLocation, courierIconBackgroundColor]);

    // Fit bounds when map and data are ready (only if user hasn't interacted)
    useEffect(() => {
        if (mapInstanceRef.current && orderSteps.length > 0 && !userHasInteracted) {
            fitBounds({
                map: mapInstanceRef.current,
                pickupSteps,
                orderSteps,
                courierLocation: !defaultSlotCourierIds.includes(
                    orderData.data?.delivery?.assignedCourier?._id?.toString()
                )
                    ? orderData.data?.courierLocation?.location
                    : null,
                estimationRoutes: estimation?.routes
            });
        }
    }, [
        mapInstanceRef.current,
        orderSteps,
        pickupSteps,
        orderData?.data?.courierLocation,
        estimation?.routes,
        userHasInteracted
    ]);

    const renderPolylines = () => {
        if (!mapInstanceRef.current) return;
        if (!estimation?.routes) return;

        // Clear existing polylines
        polylinesRef.current.forEach(polyline => {
            mapInstanceRef.current.removeLayer(polyline);
        });
        polylinesRef.current = [];

        for (let i = 0; i < estimation.routes?.length; i++) {
            if (!estimation.routes[i].encodedPolylines) {
                continue;
            }
            const routeColor = "#000000";
            let routeTopColor;
            if (i < estimation.routes.length - 1) {
                if (estimation.routes[i + 1].routeType === "fromDelivery")
                    routeTopColor = "#ff9a66";
                else if (estimation.routes[i + 1].routeType === "fromPickup")
                    routeTopColor = "#59bee9";
            } else {
                routeTopColor = "#ff9a66";
            }
            const path = decodePolyline(estimation.routes[i].encodedPolylines);

            // Convert path to Leaflet format
            const leafletPath = path.map(coord => [coord.lat, coord.lng]);

            // Create border polyline
            const polylineBorder = L.polyline(leafletPath, {
                color: routeColor,
                weight: 5,
                opacity: 1
            });

            // Create main polyline
            const polyline = L.polyline(leafletPath, {
                color: routeTopColor,
                weight: 3,
                opacity: 1
            });

            polylineBorder.addTo(mapInstanceRef.current);
            polyline.addTo(mapInstanceRef.current);
            polylinesRef.current.push(polylineBorder);
            polylinesRef.current.push(polyline);
        }
    };
    const renderPolylinesExact = () => {
        if (!mapInstanceRef.current) return;
        if (deliveryLocationsData.length > 0) {
            const newLocations = [];

            deliveryLocationsData.forEach(item =>
                newLocations.push({lat: item.coordinates[1], lng: item.coordinates[0]})
            );
            if (
                newLocations.length === 1 &&
                isEqual(exactPath[exactPath.length - 1], newLocations[0])
            ) {
                return;
            }
            setExactPath(exactPath => exactPath.concat(newLocations));

            // Convert exactPath to Leaflet format
            const leafletExactPath = exactPath.map(coord => [coord.lat, coord.lng]);

            // Create border polyline for exact path
            const polylineBorderExactPath = L.polyline(leafletExactPath, {
                color: "#000000",
                weight: 5,
                opacity: 1
            });

            // Create main polyline for exact path
            const polylineExactPath = L.polyline(leafletExactPath, {
                color: "#53e269",
                weight: 3,
                opacity: 1
            });

            polylineBorderExactPath.addTo(mapInstanceRef.current);
            polylineExactPath.addTo(mapInstanceRef.current);
            polylinesRef.current.push(polylineBorderExactPath);
            polylinesRef.current.push(polylineExactPath);
        }
    };

    const renderProofIcon = step => {
        let {proofs} = step;
        proofs = proofs.filter(p => p.label == proofs[0].label);
        let proofIcons = null;
        const emptyProof = () => <MinusCircleFilledIcon color={courierStatusColors.unavailable} />;
        const filledProof = () => {
            return (
                <>
                    {proofs.map(proof => {
                        if (
                            (step.deliveryState === "onDeliveryAddress" &&
                                step.stepInfo.orderNumber === proof.orderNumber) ||
                            (step.deliveryState === "onPickUpAddress" &&
                                step.stepInfo.orders.filter(
                                    order => order.orderNumber === proof.orderNumber
                                ).length > 0)
                        ) {
                            return (
                                <FileImageFilledIcon
                                    key={proof?._id}
                                    onClick={() => {
                                        const step =
                                            allSteps.filter(
                                                step => step?.stepIndex === proof?.stepIndex
                                            )[0] || {};
                                        const receiverName = getReceiverName(proof.orderNumber);
                                        setProofData({
                                            proof,
                                            step: {...step, receiverName}
                                        });
                                        setProofVisible(step.deliveryState);
                                    }}
                                    color={courierStatusColors.available}
                                />
                            );
                        }
                    })}
                </>
            );
        };
        const getPickUpAddress = state => allSteps.filter(step => step?.deliveryState === state);
        const getDeliveryAddress = (state, orderNumber) =>
            allSteps.filter(
                step => step?.stepInfo?.orderNumber === orderNumber && step?.deliveryState === state
            );
        const getReceiverName = orderNumber =>
            getDeliveryAddress("onDeliveryAddress", orderNumber)[0]?.stepInfo?.receiverName;
        const getProof = (step, orderNumber) =>
            step?.proofs.filter(proof => proof.orderNumber === orderNumber)[0];

        if (proofs) {
            proofIcons = filledProof();
        } else {
            proofIcons = emptyProof();
        }

        return (
            <>
                {proofIcons}
                {proofVisible == step.deliveryState ? (
                    <ProofModal
                        visible={proofVisible == step.deliveryState}
                        data={proofData}
                        handleClose={() => setProofVisible(null)}
                        changeDeliveryState={(orderNumber, deliveryState) => {
                            const selectedStep =
                                deliveryState === "onPickUpAddress"
                                    ? getPickUpAddress(deliveryState)
                                    : getDeliveryAddress(deliveryState, orderNumber);
                            const receiverName = getReceiverName(orderNumber);
                            setProofData({
                                proof: getProof(selectedStep[0], orderNumber),
                                step: {...selectedStep[0], receiverName},
                                orderNumber
                            });
                        }}
                    />
                ) : null}
            </>
        );
    };
    const renderMergedOrderStats = () => {
        if (
            delivered ||
            canceled ||
            returned ||
            inPrep ||
            inQueue ||
            orderData?.data?.delivery?.orders?.length < 2
        ) {
            return null;
        }
        let content = "";
        //active orders and merged orders
        let totalOrdersCount = orderData?.data?.delivery?.orders?.length || 0;
        let deliveredOrdersCount = 0;
        let pickedUpOrdersCount = 0;

        orderData.data?.delivery?.orders?.forEach(order => {
            const hasPickedUp = orderData?.data?.delivery?.pickupInfos?.some(
                pI => pI._id.toString() === order.pickupInfoId.toString() && pI.state === "picked"
            );
            if (hasPickedUp) {
                pickedUpOrdersCount++;
            }

            if (order.state === "delivered") {
                deliveredOrdersCount++;
            }
        });

        if (pickedUpOrdersCount > 0 || deliveredOrdersCount > 0) {
            content = (() => (
                <>
                    {t("mergedOrdersStatus.picked", {
                        ns: "orderDetail",
                        pickedUpCount: pickedUpOrdersCount,
                        totalCount: totalOrdersCount
                    })}
                    ,
                    <br />
                    {t("mergedOrdersStatus.delivered", {
                        ns: "orderDetail",
                        deliveredCount: deliveredOrdersCount,
                        totalCount: totalOrdersCount
                    })}
                </>
            ))();
        } else {
            return null;
        }

        return (
            <>
                <MergedOrderStats>{content}</MergedOrderStats>
                <br />
            </>
        );
    };

    const getColorByState = state => {
        switch (state) {
            case "canceled":
                return canceledColor;
            case "returned":
                return returnedColor;
            case "delivered":
                return deliveredColor;
            default:
                return receiverColor;
        }
    };

    const renderReceiverMarkers = orderSteps => {
        if (!mapInstanceRef.current) return;

        // Clear existing receiver markers
        markersRef.current.forEach(marker => {
            if (marker.options && marker.options.isReceiverMarker) {
                mapInstanceRef.current.removeLayer(marker);
            }
        });
        markersRef.current = markersRef.current.filter(
            marker => !marker.options || !marker.options.isReceiverMarker
        );

        orderSteps.forEach((order, index) => {
            const orders = orderData?.data?.delivery?.orders;
            const orderItem =
                orders?.length > 0 &&
                orders?.find(o => o?.orderNumber == order?.stepInfo?.orderNumber);
            let color = getColorByState(orderItem?.state);

            // Create custom marker icon
            const markerIconHtml = ReactDOMServer.renderToString(
                <MarkerIcon color={color}>O{index + 1}</MarkerIcon>
            );

            const customIcon = L.divIcon({
                html: markerIconHtml,
                className: "custom-marker-icon",
                iconSize: [35, 35],
                iconAnchor: [17.5, 17.5],
                popupAnchor: [0, -17.5]
            });

            const marker = L.marker(
                [order?.stepInfo?.receiverLocation?.lat, order?.stepInfo?.receiverLocation?.lon],
                {
                    icon: customIcon,
                    isReceiverMarker: true
                }
            );

            const popupHtml = ReactDOMServer.renderToString(
                <MarkerPopupContainer $color={color} $textColor={getReadableTextColor(color)}>
                    <MarkerPopupLabel>{`O${index + 1} - ${order?.stepInfo?.receiverName ||
                        t("fields.receiver", {ns: "common"})}`}</MarkerPopupLabel>
                </MarkerPopupContainer>
            );

            marker.bindPopup(popupHtml, {
                className: "order-detail-popup",
                closeButton: false,
                autoClose: false,
                closeOnClick: false
            });
            attachMarkerPopupInteractions(marker);
            marker.addTo(mapInstanceRef.current);
            markersRef.current.push(marker);
        });
    };

    const renderPickupMarkers = pickupSteps => {
        if (!mapInstanceRef.current) return;

        // Clear existing pickup markers
        markersRef.current.forEach(marker => {
            if (marker.options && marker.options.isPickupMarker) {
                mapInstanceRef.current.removeLayer(marker);
            }
        });
        markersRef.current = markersRef.current.filter(
            marker => !marker.options || !marker.options.isPickupMarker
        );

        pickupSteps.forEach((pickup, index) => {
            // Create custom pickup marker icon
            const pickupIconHtml = ReactDOMServer.renderToString(
                <MarkerIcon color={pickupColor}>P{index + 1}</MarkerIcon>
            );

            const customIcon = L.divIcon({
                html: pickupIconHtml,
                className: "custom-marker-icon",
                iconSize: [35, 35],
                iconAnchor: [17.5, 17.5],
                popupAnchor: [0, -17.5]
            });

            const marker = L.marker(
                [pickup?.stepInfo?.location?.latitude, pickup?.stepInfo?.location?.longitude],
                {
                    icon: customIcon,
                    isPickupMarker: true
                }
            );

            const popupHtml = ReactDOMServer.renderToString(
                <MarkerPopupContainer
                    $color={pickupColor}
                    $textColor={getReadableTextColor(pickupColor)}
                >
                    <MarkerPopupLabel>{`P${index + 1} - ${pickup?.stepInfo?.name ||
                        t("fields.pickupPoint", {ns: "common"})}`}</MarkerPopupLabel>
                </MarkerPopupContainer>
            );

            marker.bindPopup(popupHtml, {
                className: "order-detail-popup",
                closeButton: false,
                autoClose: false,
                closeOnClick: false
            });
            attachMarkerPopupInteractions(marker);
            marker.addTo(mapInstanceRef.current);
            markersRef.current.push(marker);
        });
    };

    const renderCourierMarker = () => {
        if (!mapInstanceRef.current) return;
        if (!orderData?.data?.courierLocation) return;
        if (
            defaultSlotCourierIds.includes(
                orderData.data?.delivery?.assignedCourier?._id?.toString()
            )
        )
            return;
        if (
            ["delivered", "canceled", "returned"].includes(orderData?.data?.delivery?.deliveryState)
        )
            return;

        // Clear existing courier marker
        markersRef.current.forEach(marker => {
            if (marker.options && marker.options.isCourierMarker) {
                mapInstanceRef.current.removeLayer(marker);
            }
        });
        markersRef.current = markersRef.current.filter(
            marker => !marker.options || !marker.options.isCourierMarker
        );

        // Create custom courier marker icon
        const courierIconHtml = ReactDOMServer.renderToString(
            <CourierMarkerIcon color={courierIconBackgroundColor}>
                <CourierIcon courierType={orderData.data.courierLocation.type} />
            </CourierMarkerIcon>
        );

        const customIcon = L.divIcon({
            html: courierIconHtml,
            className: "custom-marker-icon",
            iconSize: [35, 35],
            iconAnchor: [17.5, 17.5],
            popupAnchor: [0, -17.5]
        });

        const marker = L.marker(
            [
                orderData.data.courierLocation.location.coordinates[1],
                orderData.data.courierLocation.location.coordinates[0]
            ],
            {
                icon: customIcon,
                isCourierMarker: true
            }
        );

        const popupHtml = ReactDOMServer.renderToString(
            <MarkerPopupContainer
                $color={courierIconBackgroundColor}
                $textColor={getReadableTextColor(courierIconBackgroundColor)}
            >
                <MarkerPopupLabel>
                    {`${t("fields.courier", {ns: "common"})}: ${orderData.data?.delivery
                        ?.assignedCourier?.fullname || "-"}`}
                </MarkerPopupLabel>
            </MarkerPopupContainer>
        );

        marker.bindPopup(popupHtml, {
            className: "order-detail-popup",
            closeButton: false,
            autoClose: false,
            closeOnClick: false
        });
        attachMarkerPopupInteractions(marker);
        marker.addTo(mapInstanceRef.current);
        markersRef.current.push(marker);
    };

    const toggleMapMode = () => {
        if (mapMode == "fixed") {
            setMapMode("relative");
        } else {
            setMapMode("fixed");
        }
    };

    const sortedSteps = useMemo(
        () =>
            orderData?.data?.steps?.sort((a, b) =>
                new Date(b.stepIndex) > new Date(a.stepIndex) ? -1 : 1
            ),
        [orderData?.data?.steps]
    );

    const handleOrderNoteSave = async note => {
        await stores.orderStore.updateOrderOperationNote({
            deliveryId,
            orderId: selectedOrder._id,
            note
        });
        setRecall(!recallRef.current);
        setOrderNoteModalVisible(false);
    };

    const renderSiparisCol = () => (
        <>
            {" "}
            <div style={{display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px"}}>
                <OrderNumber data-testid="orderNumber" style={{marginBottom: 0}}>
                    {t("fields.orderNumber", {ns: "common"})}: {orderNumber ? orderNumber : "-"}
                </OrderNumber>
            </div>
            {/* Harita */}
            <Row gutter={[0, 30]}>
                <MapContainer mode={mapMode} data-testid="map">
                    <MapLegend>
                        <div className="legend-item">
                            <div className="legend-line" style={{backgroundColor: "#53e269"}}></div>
                            <div className="legend-text">Gerçekleşen Güzergah</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-line" style={{backgroundColor: "#ff9a66"}}></div>
                            <div className="legend-text">Planlanan Güzergah</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-line" style={{backgroundColor: "#59bee9"}}></div>
                            <div className="legend-text">Kurye Başlangıç Güzergahı</div>
                        </div>
                    </MapLegend>
                    <MapDiv ref={mapRef} />
                    {/* Sağ Üst Kontroller */}
                    <div
                        style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            zIndex: 1000,
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px"
                        }}
                    >
                        {/* Harita Büyütme Butonu */}
                        <MapTools
                            onClick={e => {
                                toggleMapMode();
                                e.currentTarget.blur();
                            }}
                        >
                            {mapMode == "relative" ? <ArrowsAltOutlined /> : <ShrinkOutlined />}
                        </MapTools>
                        {/* Tile Layer Control */}
                        {mapInstanceRef.current && (
                            <TileLayerControl
                                mapInstance={mapInstanceRef.current}
                                tileLayerRef={tileLayerRef}
                                style={{right: "50px", top: "10px"}}
                            />
                        )}
                    </div>
                </MapContainer>
            </Row>
            <TableTitle>
                {deliveryType === "productReturn"
                    ? t("fields.returnPoints", {ns: "common"})
                    : t("fields.deliveryPoints", {ns: "common"})}
            </TableTitle>
            {/* Sipariş Tablosu */}
            <TableOverflowWithBorder>
                <OrderTableCustom
                    data-testid="orderTable"
                    onRow={(record, index) => {
                        return {
                            onMouseEnter: event => {
                                setHover(record.stepInfo._id);
                            },
                            style: {
                                backgroundColor:
                                    (record.stepInfo.passed &&
                                        (hover === record.stepInfo._id
                                            ? colorIndexList[record.stepInfo._id]
                                            : "white")) ||
                                    (record.reorderOf &&
                                        (hover === record.stepInfo._id
                                            ? colorIndexList[record.stepInfo._id]
                                            : "white"))
                            },
                            onMouseLeave: event => {
                                setHover("");
                            }
                        };
                    }}
                    rowKey="_id"
                    dataSource={orderSteps}
                    pagination={false}
                    expandable={{
                        columnWidth: "20px",
                        expandedRowRender: record => {
                            const order = orderData?.data?.delivery?.orders.filter(
                                i => i?.orderNumber === record?.stepInfo?.orderNumber
                            );
                            return (
                                <>
                                    <OrderDetailContainer>
                                        <OrderDetailTitle>
                                            {t("fields.orderDetails", {
                                                ns: "common"
                                            })}
                                        </OrderDetailTitle>
                                        <hr />
                                        <OrderDetailContent>
                                            {/* sipariş no */}
                                            {order && order[0]?.orderNumber && (
                                                <OrderDetailRow>
                                                    <OrderDetailLabel>
                                                        Sipariş Numarası:
                                                    </OrderDetailLabel>
                                                    <OrderDetailValue>
                                                        {order[0].orderNumber}
                                                    </OrderDetailValue>
                                                </OrderDetailRow>
                                            )}
                                            {/* adres */}
                                            {order && order[0]?.receiverAddress && (
                                                <OrderDetailRow>
                                                    <OrderDetailLabel>Adres:</OrderDetailLabel>
                                                    <OrderDetailValue>
                                                        {order[0].receiverAddress}
                                                    </OrderDetailValue>
                                                </OrderDetailRow>
                                            )}
                                            {/* adres tarifi*/}
                                            {order && order[0]?.receiverAddressDetail && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        gap: "8px"
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#888",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            minWidth: "100px",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        Adres Tarifi:
                                                    </span>
                                                    <div
                                                        style={{
                                                            color: "#222",
                                                            fontWeight: 500,
                                                            fontSize: 13,
                                                            flex: 1
                                                        }}
                                                    >
                                                        {order[0].receiverAddressDetail}
                                                    </div>
                                                </div>
                                            )}
                                            {/* telefon */}
                                            {order && order[0]?.receiverPhone && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px"
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#888",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            minWidth: "100px",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        Telefon:
                                                    </span>
                                                    <div
                                                        style={{
                                                            color: "#222",
                                                            fontWeight: 500,
                                                            fontSize: 13,
                                                            flex: 1
                                                        }}
                                                    >
                                                        {order[0].receiverPhone}
                                                    </div>
                                                </div>
                                            )}
                                            {/* ödeme tipi */}
                                            {order && (order[0]?.paymentType || order[0]?.price) && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px"
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#888",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            minWidth: "100px",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        {t("fields.amount", {
                                                            ns: "common"
                                                        })}
                                                        :
                                                    </span>
                                                    <div
                                                        style={{
                                                            color: "#222",
                                                            fontWeight: 500,
                                                            fontSize: 13,
                                                            flex: 1
                                                        }}
                                                    >
                                                        <b>{`${order[0].price || "0"}₺ `}</b>
                                                    </div>
                                                </div>
                                            )}
                                            {/* sipariş notu */}
                                            {order && order[0]?.note && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        gap: "8px"
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#888",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            minWidth: "100px",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        Sipariş Notu:
                                                    </span>
                                                    <div
                                                        style={{
                                                            color: "#222",
                                                            fontWeight: 500,
                                                            fontSize: 13,
                                                            flex: 1
                                                        }}
                                                    >
                                                        {order[0].note}
                                                    </div>
                                                </div>
                                            )}
                                            {/* operasyon notu */}
                                            {order && order[0]?.operationNote && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        gap: "8px"
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#888",
                                                            fontSize: 12,
                                                            fontWeight: 500,
                                                            minWidth: "100px",
                                                            flexShrink: 0
                                                        }}
                                                    >
                                                        Operasyon Notu:
                                                    </span>
                                                    <div
                                                        style={{
                                                            color: "#222",
                                                            fontWeight: 500,
                                                            fontSize: 13,
                                                            flex: 1
                                                        }}
                                                    >
                                                        {order[0].operationNote}
                                                    </div>
                                                </div>
                                            )}
                                        </OrderDetailContent>
                                    </OrderDetailContainer>
                                    <ProductTableContainer>
                                        <ProductTable
                                            showNote={false}
                                            showPaymentInfo={false}
                                            showBarcode={false}
                                            dataSource={order ? order?.[0]?.products : []}
                                            pagination={false}
                                            note={record.stepInfo.note}
                                            price={record.stepInfo.price}
                                            paymentType={record.stepInfo.paymentType}
                                            barcode={record.stepInfo.barcode}
                                        />
                                    </ProductTableContainer>
                                </>
                            );
                        }
                    }}
                    size="small"
                >
                    {/* Sıra Numarası */}
                    <Column
                        title={"#"}
                        dataIndex="stepInfo"
                        align="center"
                        width={"50px"}
                        render={(text, record) => {
                            const orders = orderData?.data?.delivery?.orders || [];
                            const order = orders?.find(order => order?._id === text?._id);
                            const orderIndex = order?.index;
                            const color = getColorByState(order?.state);

                            const handleOrderClick = () => {
                                if (
                                    order?.receiverLocation?.lat &&
                                    order?.receiverLocation?.lon &&
                                    mapInstanceRef.current
                                ) {
                                    const lat = parseFloat(order.receiverLocation.lat);
                                    const lng = parseFloat(order.receiverLocation.lon);

                                    if (lat && lng) {
                                        const map = mapInstanceRef.current;
                                        setUserHasInteracted(true);
                                        if (map.getZoom() !== 16) {
                                            map.setZoom(16, {animate: false});
                                        }
                                        map.setView([lat, lng], 16, {
                                            animate: true
                                        });
                                    }
                                }
                            };

                            return (
                                <span
                                    style={{
                                        background: color,
                                        border: "3px solid " + color,
                                        borderRadius: "50%",
                                        boxShadow: "0 0 0 1px black",
                                        cursor: "pointer",
                                        width: "32px",
                                        height: "32px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "bold"
                                    }}
                                    onClick={handleOrderClick}
                                    title={`${order?.receiverName || "Müşteri"} konumuna git`}
                                >
                                    {"O" + orderIndex}
                                </span>
                            );
                        }}
                    />
                    {/* Sipariş Numarası */}
                    <Column
                        title={t("fields.orderNumber", {ns: "common"})}
                        dataIndex="stepInfo"
                        align="center"
                        width={"100px"}
                        render={text => {
                            const orders = orderData?.data?.delivery?.orders || [];
                            const order = orders?.find(order => order?._id === text?._id);
                            const orderNumber = order?.orderNumber;

                            return (
                                <Tooltip title={orderNumber}>
                                    <span
                                        style={{
                                            display: "block",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            maxWidth: "100px"
                                        }}
                                    >
                                        {orderNumber}
                                    </span>
                                </Tooltip>
                            );
                        }}
                    />
                    {/* Firma Adı */}
                    <Column
                        dataIndex="stepInfo"
                        title={t("fields.companyName", {ns: "common"})}
                        align="center"
                        render={value => {
                            const orders = orderData?.data?.delivery?.orders || [];
                            const order = orders?.find(order => order?._id === value?._id);
                            const tooltipTitle =
                                "Firma: " +
                                order?.pickupInfoCompanyName +
                                " - " +
                                "Şube: " +
                                order?.pickupInfoName;

                            const companyName = order?.pickupInfoCompanyName;
                            return (
                                <Tooltip title={tooltipTitle}>
                                    <span data-testid="receiverCompany">
                                        {companyName ? companyName + "..." : ""}
                                    </span>
                                </Tooltip>
                            );
                        }}
                    />
                    {/* Müşteri Adı */}
                    <Column
                        dataIndex="stepInfo"
                        title={
                            deliveryType === "productReturn"
                                ? t("fields.returnPoint", {ns: "common"})
                                : t("fields.customerNameOrReceiptNumber", {ns: "common"})
                        }
                        align="center"
                        render={text => {
                            const orders = orderData?.data?.delivery?.orders || [];
                            const order = orders?.find(order => order?._id === text?._id);

                            return (
                                <span data-testid="receiverName">
                                    {order?.receiptNumber && text?.receiverName
                                        ? order?.receiptNumber + " / " + text?.receiverName
                                        : order?.receiptNumber || text?.receiverName || "-"}
                                </span>
                            );
                        }}
                    />
                    {/* Mesafe Bilgisi */}
                    <Column
                        dataIndex="stepInfo"
                        title={"Mesafe Bilgisi"}
                        align="center"
                        render={(stepInfo, record) => (
                            <Tooltip title={record?.stepInfo?.distance + " metre"}>
                                <span
                                    data-testid="distance"
                                    style={{
                                        borderBottom: "1px dotted #999"
                                    }}
                                >
                                    {record?.stepInfo?.distance
                                        ? (record.stepInfo.distance / 1000).toFixed(2) + " km"
                                        : "-"}
                                </span>
                            </Tooltip>
                        )}
                    />
                    {/* Ödeme Yöntemi */}
                    <Column
                        dataIndex="paymentType"
                        title={t("fields.payment", {ns: "common"})}
                        align="center"
                        render={(text, record) => {
                            const paymentType = record?.stepInfo?.paymentType;
                            const paymentMethod = record?.stepInfo?.vigoPayment;
                            const getPaymentText = type => {
                                switch (type) {
                                    case "paid":
                                        return "Ödendi";
                                    case "creditCard":
                                        return "Kredi Kartı";
                                    case "cash":
                                        return "Nakit";
                                    case "ticketRestaurantCard":
                                        return "Ticket Restaurant Kart";
                                    case "ticketRestaurantVoucher":
                                        return "Ticket Restaurant Fiş";
                                    case "sodexoRestaurantPass":
                                        return "Sodexo Restaurant Pass";
                                    case "sodexoRestaurantPassMobilePayment":
                                        return "Sodexo Restaurant Pass Mobil";
                                    case "sodexoOnline":
                                        return "Sodexo Online";
                                    case "sodexoCard":
                                        return "Sodexo Kart";
                                    case "multinet":
                                        return "Multinet";
                                    case "setCard":
                                        return "SetCard";
                                    case "yemekmatikYemekKart":
                                        return "Yemekmatik Yemek Kart";
                                    case "metropolCard":
                                        return "Metropol Kart";
                                    case "cioCard":
                                        return "CIO Kart";
                                    case "payeCard":
                                        return "Paye Kart";
                                    case "winWin":
                                        return "WinWin";
                                    case "tokenFlex":
                                        return "Token Flex";
                                    case "unspecified":
                                        return "Belirtilmemiş";
                                    default:
                                        return paymentType || "-";
                                }
                            };

                            return (
                                <span data-testid="paymentType">
                                    {getPaymentText(paymentType)}
                                    {paymentMethod ? `(${codPaymentBrandLabel})` : ""}
                                </span>
                            );
                        }}
                    />
                    {/* Fiş */}
                    {orderData?.data?.delivery?.orders.some(order => order?.receipt !== null) ? (
                        <Column
                            dataIndex="stepInfo"
                            title={t("fields.orderReceipt", {ns: "common"})}
                            align="center"
                            render={stepInfo => {
                                const receipt = orderData?.data?.delivery?.orders.find(
                                    o => o._id.toString() === stepInfo._id
                                )?.receipt;

                                return (
                                    <Image
                                        src={receipt?.publicUrl}
                                        width={200}
                                        height={200}
                                        style={{
                                            objectFit: "contain"
                                        }}
                                    />
                                );
                            }}
                        />
                    ) : null}
                    {/* Aksiyon Butonları */}
                    {stores.meStore.checkRole("updateOrder") &&
                        stores.meStore.checkPermission("orders.orderActions") &&
                        orderData.data.delivery.orders.length > 0 && (
                            <Column
                                align="center"
                                dataIndex="stepInfo"
                                title={t("actions.action", {ns: "common"})}
                                render={(text, row) => {
                                    const currentStepIndex =
                                        orderData.data.delivery.currentStepIndex;
                                    const lastOrderStepIndex =
                                        orderSteps[orderSteps.length - 1].stepIndex;

                                    const passButton =
                                        row.stepIndex === currentStepIndex &&
                                        currentStepIndex !== lastOrderStepIndex;
                                    const reOrderButton =
                                        row.stepInfo.passed && !row.stepInfo.reOrdered;
                                    const isReordered =
                                        orderData.data?.delivery?.orders.find(
                                            o => o._id.toString() === text._id
                                        )?.state === "reOrdered";

                                    const disabled =
                                        delivered ||
                                        canceled ||
                                        orderData.data.delivery.deliveryState ===
                                            "onTheWayForReturn" ||
                                        orderData.data.delivery.deliveryState === "onReturnAddress";

                                    const orders = orderData?.data?.delivery?.orders || [];
                                    const order = orders?.find(
                                        order => order?._id === row?.stepInfo?._id
                                    );
                                    const companyName = order?.pickupInfoCompanyName;

                                    return (
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                                gap: "5px",
                                                alignItems: "center",
                                                minWidth: "160px"
                                            }}
                                        >
                                            {row.stepInfo.passed && (
                                                <Popover
                                                    content={
                                                        <span>
                                                            {row.stepInfo.passReason
                                                                ? row.stepInfo.passReason
                                                                : t("passReasonProblem", {
                                                                      ns: "orderDetail"
                                                                  })}
                                                        </span>
                                                    }
                                                    title={t("reason", {
                                                        ns: "orderDetail"
                                                    })}
                                                    placement="rightTop"
                                                    trigger="hover"
                                                >
                                                    <DetailTag
                                                        icon={<CheckCircleOutlined />}
                                                        color="success"
                                                        style={{
                                                            width: "100%",
                                                            marginTop: "0px",
                                                            marginBottom: "0px",
                                                            fontSize: "16px",
                                                            padding: "unset"
                                                        }}
                                                    >
                                                        {t("passed", {
                                                            ns: "orderDetail"
                                                        })}
                                                    </DetailTag>
                                                </Popover>
                                            )}

                                            {stores.meStore.checkRole("passOrder") &&
                                            stores.meStore.checkPermission("orders.orderActions") ? (
                                                <Popover
                                                    content={
                                                        reOrderButton
                                                            ? t("actions.sendAgain", {
                                                                  ns: "orderDetail"
                                                              })
                                                            : t("actions.pass", {
                                                                  ns: "orderDetail"
                                                              })
                                                    }
                                                >
                                                    <PassButton
                                                        data-testid={`${
                                                            reOrderButton ? "sendAgain" : "pass"
                                                        }Button`}
                                                        disabled={
                                                            (!reOrderButton && !passButton) ||
                                                            isReordered ||
                                                            disabled
                                                        }
                                                        onClick={() => {
                                                            if (reOrderButton) {
                                                                reOrder({
                                                                    deliveryId,
                                                                    orderId: text._id
                                                                });
                                                            }
                                                            if (passButton) {
                                                                setModalVisible(!modalVisible);
                                                                setModalType("pass");
                                                                setModalData({
                                                                    deliveryId,
                                                                    orderId: text._id
                                                                });
                                                            }
                                                        }}
                                                        style={{
                                                            marginTop: "0px",
                                                            marginBottom: "0px",
                                                            width: "100%",
                                                            height: "28px",
                                                            fontSize: "16px",
                                                            padding: "unset"
                                                        }}
                                                    >
                                                        <DoubleRightOutlined />
                                                    </PassButton>
                                                </Popover>
                                            ) : (
                                                <div></div>
                                            )}

                                            <Popover
                                                content={
                                                    orderData?.data?.delivery?.orders.find(
                                                        order => order?._id === text._id
                                                    )?.operationNote
                                                        ? "Not Düzenle"
                                                        : "Not Ekle"
                                                }
                                            >
                                                <Button
                                                    type="primary"
                                                    size="small"
                                                    style={{
                                                        backgroundColor: "#FFD700",
                                                        color: "black",
                                                        borderColor: "#FFD700",
                                                        width: "100%",
                                                        height: "28px",
                                                        fontSize: "16px"
                                                    }}
                                                    onClick={() => {
                                                        setSelectedOrder(order);
                                                        getOperationNoteAndModal({
                                                            orderId: text._id,
                                                            modalVisible: true
                                                        });
                                                    }}
                                                >
                                                    <CommentOutlined />
                                                </Button>
                                            </Popover>

                                            <Popover content={<span>Fişi görüntüle</span>}>
                                                <Button
                                                    type="primary"
                                                    size="small"
                                                    style={{
                                                        width: "100%",
                                                        height: "28px",
                                                        fontSize: "16px"
                                                    }}
                                                    onClick={() => {
                                                        setSelectedOrder(order);
                                                        setReceiptModalVisible(true);
                                                    }}
                                                >
                                                    <FileTextOutlined />
                                                </Button>
                                            </Popover>

                                            <Popover
                                                content={t("actions.cancel", {
                                                    ns: "orderDetail"
                                                })}
                                            >
                                                <AnnulmentButton
                                                    type="danger"
                                                    size="small"
                                                    data-testid="cancelButton"
                                                    disabled={
                                                        row.stepInfo.canceled ||
                                                        orderData.data.delivery.currentStepIndex >
                                                            row.stepIndex ||
                                                        ["delivered", "canceled"].includes(
                                                            orderData.data.delivery.deliveryState
                                                        )
                                                    }
                                                    onClick={() => {
                                                        setModalVisible(!modalVisible);
                                                        setModalType("cancelOrderByNumber");
                                                        setModalData({
                                                            vigoOrderNumber: text.vigoOrderNumber,
                                                            orderNumber: text.orderNumber
                                                        });
                                                    }}
                                                    style={{
                                                        width: "100%",
                                                        height: "28px",
                                                        fontSize: "16px"
                                                    }}
                                                >
                                                    <CloseOutlined />
                                                </AnnulmentButton>
                                            </Popover>
                                        </div>
                                    );
                                }}
                            />
                        )}
                </OrderTableCustom>
                <ReceiptPrinter
                    key={selectedOrder?._id}
                    receipt={selectedOrder?.receipt}
                    receiptModalVisible={receiptModalVisible}
                    setReceiptModalVisible={setReceiptModalVisible}
                    order={selectedOrder}
                    orderData={orderData}
                    receiptRef={receiptRef}
                    setIsReceiptPrinting={setIsReceiptPrinting}
                    isReceiptPrinting={isReceiptPrinting}
                />
            </TableOverflowWithBorder>
            <TableTitle>
                {deliveryType === "productReturn"
                    ? t("fields.returnPickupPoints", {ns: "common"})
                    : t("fields.pickupPoints", {ns: "common"})}
            </TableTitle>
            {/* Teslimat Noktaları */}
            <PickupTableCustom
                rowKey="_id"
                dataSource={pickupSteps}
                pagination={false}
                data-testid="collectingPointTable"
                expandable={{
                    columnWidth: "20px",
                    expandedRowRender: record => {
                        return (
                            <ProductTableContainer>
                                <ProductTable
                                    dataSource={record.products}
                                    pagination={false}
                                    showNote={false}
                                    showPaymentInfo={false}
                                    showBarcode={false}
                                />
                            </ProductTableContainer>
                        );
                    }
                }}
                style={{border: "1px solid #e8e8e8"}}
                size="small"
            >
                <Column
                    dataIndex="stepInfo"
                    title={"#"}
                    align="center"
                    width={"50px"}
                    render={text => {
                        const handlePickupClick = () => {
                            if (
                                text?.location?.latitude &&
                                text?.location?.longitude &&
                                mapInstanceRef.current
                            ) {
                                const lat = parseFloat(text.location.latitude);
                                const lng = parseFloat(text.location.longitude);

                                if (lat && lng) {
                                    const map = mapInstanceRef.current;
                                    setUserHasInteracted(true);
                                    if (map.getZoom() !== 16) {
                                        map.setZoom(16, {animate: false});
                                    }
                                    map.setView([lat, lng], 16, {
                                        animate: true
                                    });
                                }
                            }
                        };

                        return (
                            <span
                                data-testid="index"
                                style={{
                                    background: pickupColor,
                                    border: "3px solid " + pickupColor,
                                    borderRadius: "50%",
                                    boxShadow: "0 0 0 1px black",
                                    cursor: "pointer",
                                    width: "32px",
                                    height: "32px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: "bold"
                                }}
                                onClick={handlePickupClick}
                                title={`${text?.name || "Toplama Noktası"} konumuna git`}
                            >
                                {"P" + text.index}
                            </span>
                        );
                    }}
                />
                <Column
                    dataIndex="stepInfo"
                    title={
                        deliveryType === "productReturn"
                            ? t("fields.customerName", {ns: "common"})
                            : t("fields.warehouseName", {ns: "common"})
                    }
                    render={text => <span data-testid="name">{text.name}</span>}
                />
                <Column
                    dataIndex="stepInfo"
                    title={t("fields.phone", {ns: "common"})}
                    render={text => (
                        <span data-testid="phone">{formatPhoneNumber(text.phone)}</span>
                    )}
                />
                <Column
                    dataIndex="stepInfo"
                    title={t("fields.address", {ns: "common"})}
                    render={text => <span data-testid="address">{text.address}</span>}
                />
            </PickupTableCustom>
            {orderData.data.delivery.orders &&
            orderData.data.delivery.orders[0] &&
            orderData.data.delivery.orders[0].platformPickingTime ? (
                <PlatformDeliveryDetailTable orders={orderData.data.delivery.orders} />
            ) : (
                ""
            )}
            {returnSteps.length >= 1 && (
                <>
                    <TableTitle>{t("returnPoints", {ns: "orderDetail"})}</TableTitle>
                    <ReturnTableCustom
                        rowKey="_id"
                        dataSource={returnSteps}
                        pagination={false}
                        data-testid="returnSteps"
                        size="small"
                        expandable={{
                            columnWidth: "20px",
                            expandedRowRender: record => {
                                return (
                                    <ProductTableContainer>
                                        <ProductTable
                                            dataSource={record.stepInfo.products}
                                            pagination={false}
                                            showNote={false}
                                            showPaymentInfo={false}
                                            showBarcode={false}
                                        />
                                    </ProductTableContainer>
                                );
                            }
                        }}
                        style={{border: "1px solid #e8e8e8"}}
                    >
                        <Column
                            dataIndex="stepInfo"
                            title={"#"}
                            align="center"
                            width={"50px"}
                            render={text => (
                                <span
                                    data-testid="index"
                                    style={{
                                        background: pickupColor,
                                        border: "3px solid " + pickupColor,
                                        borderRadius: "50%",
                                        boxShadow: "0 0 0 1px black",
                                        padding: "4px",
                                        fontWeight: "bold"
                                    }}
                                >
                                    {"P" + text.index}
                                </span>
                            )}
                        />
                        <Column
                            dataIndex="stepInfo"
                            title={
                                deliveryType === "productReturn"
                                    ? t("fields.customerName", {ns: "common"})
                                    : t("fields.warehouseName", {ns: "common"})
                            }
                            data-testid="name"
                            render={text => text.name}
                        />
                        <Column
                            dataIndex="stepInfo"
                            title={t("fields.phone", {ns: "common"})}
                            data-testid="phone"
                            render={text => formatPhoneNumber(text.phone)}
                        />
                        <Column
                            dataIndex="stepInfo"
                            title={t("fields.address", {ns: "common"})}
                            data-testid="address"
                            render={text => text.address}
                        />
                    </ReturnTableCustom>
                </>
            )}
            {stores.meStore.checkRole("notVisibleForCompanyUser") &&
                orderData.data.courierLocation && (
                    <>
                        <TableTitle>{t("fields.courier", {ns: "common"})}</TableTitle>
                        <DescriptionContainer
                            column={{xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2}}
                            bordered
                            size="small"
                            style={{
                                fontSize: "13px"
                            }}
                        >
                            <DescriptionContainer.Item
                                label={t("fields.courierName", {ns: "common"})}
                                span={{xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1}}
                            >
                                <span data-testid="courierName">
                                    {orderData.data?.delivery?.assignedCourier?.fullname}
                                </span>
                            </DescriptionContainer.Item>

                            <DescriptionContainer.Item
                                label={t("fields.phone", {ns: "common"})}
                                span={{xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1}}
                            >
                                <span data-testid="courierPhone">
                                    {formatPhoneNumber(
                                        orderData.data?.delivery?.assignedCourier?.cellPhone
                                    )}
                                </span>
                            </DescriptionContainer.Item>
                        </DescriptionContainer>
                    </>
                )}
            {stores.meStore.checkRole("notVisibleForCompanyUser") &&
                orderData.data.delivery.orders &&
                orderData.data.delivery.orders.some(order => order.callback) && (
                    <Collapse style={{marginBottom: 16}}>
                        <Collapse.Panel
                            header={t("fields.orderInformations", {ns: "common"})}
                            key="orderInformations"
                        >
                            <CountdownButton countdown={5} onClick={triggerCallback} />
                            <Table
                                className="callback-orders-table"
                                bordered
                                rowKey="_id"
                                dataSource={orderData.data.delivery.orders.filter(
                                    order => order.callback
                                )}
                                pagination={false}
                                data-testid="collectingPointTable"
                                size="small"
                                scroll={{x: 500}}
                                expandable={{
                                    expandedRowRender: record => (
                                        <Table
                                            bordered
                                            pagination={false}
                                            dataSource={record.orderInformations}
                                            size="small"
                                            scroll={{x: 500}}
                                        >
                                            <Column
                                                dataIndex="meta"
                                                title={t("fields.status", {
                                                    ns: "common"
                                                })}
                                                render={text => (
                                                    <span data-testid="name">{text.state}</span>
                                                )}
                                            />
                                            <Column
                                                dataIndex="meta"
                                                title={t("fields.explanation", {
                                                    ns: "common"
                                                })}
                                                render={text => {
                                                    const statusObj = mapDeliveryStatuses.find(
                                                        status => status.value === text.state
                                                    );
                                                    let displayName = statusObj?.name || "";
                                                    if (
                                                        typeof text?.approachDistanceInMeters ===
                                                        "number"
                                                    ) {
                                                        const distanceInMetersText = `(${text.approachDistanceInMeters} metre)`;
                                                        displayName = (
                                                            <span>
                                                                {statusObj?.name}
                                                                <span
                                                                    style={{
                                                                        color: "#32CD32"
                                                                    }}
                                                                >
                                                                    <br />
                                                                    {distanceInMetersText}
                                                                </span>
                                                            </span>
                                                        );
                                                    }
                                                    return (
                                                        <span data-testid="name">
                                                            {displayName}
                                                        </span>
                                                    );
                                                }}
                                            />
                                            <Column
                                                dataIndex="isSent"
                                                title={t("fields.isSentInfo", {
                                                    ns: "common"
                                                })}
                                                render={text => (
                                                    <span data-testid="name">
                                                        {text ? "İletildi" : "İletilmedi"}
                                                    </span>
                                                )}
                                            />
                                            <Column
                                                dataIndex="retryCount"
                                                title={t("fields.retryCount", {
                                                    ns: "common"
                                                })}
                                                render={text => (
                                                    <span data-testid="name">{text}</span>
                                                )}
                                            />
                                            <Column
                                                dataIndex="createdAt"
                                                title={t("fields.callbackCreatedAt", {
                                                    ns: "common"
                                                })}
                                                render={text => (
                                                    <span data-testid="name">
                                                        {text
                                                            ? moment(text).format(
                                                                  "DD-MM-YYYY HH:mm:ss"
                                                              )
                                                            : ""}
                                                    </span>
                                                )}
                                            />
                                            <Column
                                                dataIndex="sentAt"
                                                title={t("fields.sentAt", {
                                                    ns: "common"
                                                })}
                                                render={text => (
                                                    <span data-testid="name">
                                                        {text
                                                            ? moment(text).format(
                                                                  "DD-MM-YYYY HH:mm:ss"
                                                              )
                                                            : ""}
                                                    </span>
                                                )}
                                            />
                                        </Table>
                                    )
                                }}
                            >
                                <Column
                                    dataIndex="orderNumber"
                                    title={t("fields.orderNumber", {ns: "common"})}
                                    render={text => <span data-testid="name">{text}</span>}
                                />
                                <Column
                                    title={t("fields.informationCount", {
                                        ns: "common"
                                    })}
                                    render={(_, {orderInformations}) => (
                                        <span data-testid="name">{orderInformations.length}</span>
                                    )}
                                />
                                <Column
                                    title={t("fields.sentInformationCount", {
                                        ns: "common"
                                    })}
                                    render={(_, {orderInformations}) => (
                                        <span data-testid="name">
                                            {orderInformations.filter(info => info.isSent).length}
                                        </span>
                                    )}
                                />
                            </Table>
                        </Collapse.Panel>
                    </Collapse>
                )}
        </>
    );

    const renderDetayCol = () => (
        <>
            {" "}
            {orderData.data?.delivery.customType == "slot" && (
                <SlotDetailCard orderData={orderData}></SlotDetailCard>
            )}
            {/*@TODO: split this component  */}
            <StepContainer
                data-testid="orderDetailCard"
                data-testvalue={
                    orderData.data?.steps?.slice(-1)[0]?.endDate && delivered
                        ? orderData.data.delivery.currentStepIndex
                        : orderData.data.delivery.currentStepIndex - 1
                }
            >
                <TableTitle>
                    {deliveryType === "productReturn"
                        ? t("returnDetail", {ns: "orderDetail"})
                        : t("orderDetail", {ns: "orderDetail"})}
                    {stores.meStore.checkRole("notVisibleForCompanyUser") &&
                        stores.meStore.checkPermission("orders.orderActions") &&
                        !delivered &&
                        !canceled &&
                        !returned &&
                        (process.env.REACT_APP_ENV === "development" ||
                            process.env.REACT_APP_ENV === "staging" ||
                            stores.meStore.role == "admin" ||
                            stores.meStore.role === "superadmin" ||
                            stores.meStore.role === "bm" ||
                            stores.meStore.role === "agency") && (
                            <RightButton
                                disabled={loading}
                                onClick={updateStep}
                                data-testid="nextStepButton"
                                icon={loading ? <LoadingOutlined /> : <FastForwardOutlined />}
                            >
                                {loading
                                    ? t("loading", {ns: "orderDetail"})
                                    : t("actions.nextStep", {ns: "orderDetail"})}
                            </RightButton>
                        )}
                </TableTitle>
                <NextStepModal
                    isOpenNextStepModal={isOpenNextStepModal}
                    setIsOpenNextStepModal={setIsOpenNextStepModal}
                    nextStepData={nextStepData?.data}
                />
                {loading && (
                    <SpinnerContainer>
                        <Spin spinning={loading} />
                    </SpinnerContainer>
                )}
                <OrderSteps
                    orderData={orderData}
                    transferData={transferData}
                    renderProofIcon={renderProofIcon}
                />
                {renderMergedOrderStats()}
                <OrderTotalTime>
                    {t("fields.elapsedTime", {ns: "common"})}: <span data-testid="deliveredTime" />
                    {delivered
                        ? calculateElapsedTime(totalTime, deliveredTime)
                        : orderData?.data?.delivery?.merged ||
                          orderData?.data?.delivery?.summary?.types?.some(
                              type => type === "autoCanceled"
                          )
                        ? calculateElapsedTime(
                              orderData.data.delivery.createdAt,
                              orderData.data.delivery.cancelDate
                          )
                        : sortedSteps[sortedSteps.length - 1]?.endDate
                        ? calculateElapsedTime(
                              orderData.data.delivery.createdAt,
                              sortedSteps[sortedSteps.length - 1]?.endDate
                          )
                        : canceled
                        ? t("canceled.shortName", {ns: "deliveryStatuses"})
                        : calculateElapsedTime(totalTime, new Date())}
                </OrderTotalTime>
            </StepContainer>
            {transferData?.data?.length > 0 && (
                <TransferInfoContainer data-testid="transferInfoCard">
                    <TableTitle>{t("transferHistory", {ns: "orderDetail"})}</TableTitle>
                    <TransferLogList
                        itemLayout="vertical"
                        split={false}
                        loading={transferLoading}
                        dataSource={transferData.data}
                        renderItem={(item, index) => (
                            <>
                                <List.Item data-testvalue={index} data-testid="from">
                                    <List.Item.Meta
                                        avatar={
                                            <Avatar
                                                size={50}
                                                data-testid="courierPhoto"
                                                src={
                                                    item.fromCourier?.photo
                                                        ? `${config.getBasePublicUrl()}api/panel/v1/image/${
                                                              item.fromCourier?.photo
                                                          }`
                                                        : placeholder
                                                }
                                            />
                                        }
                                        title={
                                            <a
                                                data-testid="courierName"
                                                href={`${config.getBasePublicUrl()}couriers/${
                                                    item.fromCourier._id
                                                }`}
                                            >
                                                {item.fromCourier?.fullname}
                                            </a>
                                        }
                                        description={
                                            <>
                                                <Row data-testid="description">
                                                    {index === 0 ? (
                                                        <TransferDescription>
                                                            <Text type="success">
                                                                {t("fields.start", {
                                                                    ns: "common"
                                                                })}
                                                                :{" "}
                                                            </Text>
                                                            <span data-testid="startTime">
                                                                {moment(
                                                                    orderData.data?.delivery
                                                                        .createdAt
                                                                ).format("HH:mm:ss")}
                                                            </span>
                                                        </TransferDescription>
                                                    ) : (
                                                        <TransferDescription>
                                                            <Text type="danger"> Transfer: </Text>
                                                            <span data-testid="transferTime">
                                                                {moment(item?.createdAt).format(
                                                                    "HH:mm:ss"
                                                                )}
                                                            </span>
                                                        </TransferDescription>
                                                    )}
                                                </Row>
                                            </>
                                        }
                                    />
                                </List.Item>
                                {index === transferData.data.length - 1 && (
                                    <List.Item data-testvalue={index + 1} data-testid="to">
                                        <List.Item.Meta
                                            avatar={
                                                <Avatar
                                                    data-testid="courierPhoto"
                                                    size={50}
                                                    src={
                                                        item.toCourier?.photo
                                                            ? `${config.getBasePublicUrl()}api/panel/v1/image/${
                                                                  item.toCourier?.photo
                                                              }`
                                                            : placeholder
                                                    }
                                                />
                                            }
                                            title={
                                                <a
                                                    data-testid="courierName"
                                                    href={`${config.getBasePublicUrl()}couriers/${
                                                        item.toCourier._id
                                                    }`}
                                                >
                                                    {item.toCourier?.fullname}
                                                </a>
                                            }
                                            description={
                                                <TransferDescription>
                                                    <Text type="danger"> Transfer: </Text>
                                                    <span data-testid="transferTime">
                                                        {moment(item?.createdAt).format("HH:mm:ss")}
                                                    </span>
                                                </TransferDescription>
                                            }
                                        />
                                    </List.Item>
                                )}
                            </>
                        )}
                    />
                </TransferInfoContainer>
            )}
        </>
    );

    return (
        <div style={{maxWidth: "100vw", overflowX: "hidden"}}>
            {!orderData.data || orderData.status !== 200 ? (
                <Skeleton paragraph={{rows: 10, width: "100%"}} active={true}></Skeleton>
            ) : (
                <React.Fragment>
                    <TextBoxFormModal
                        isVisible={modalVisible}
                        setVisible={() => setModalVisible(!modalVisible)}
                        okFunction={submit}
                        label={text.label}
                        title={text.title}
                        modalType={modalType}
                        modalData={modalData}
                        deliveryId={deliveryId}
                        deliveryData={orderData.data}
                        cancelFn={() => {
                            setHideOrderError(false);
                            setModalType("");
                        }}
                        deliveryType={deliveryType}
                    />
                    {isMobile ? (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    marginBottom: 8,
                                    maxWidth: "100vw",
                                    overflowX: "hidden"
                                }}
                            >
                                <button
                                    style={{
                                        flex: 1,
                                        background:
                                            activeMobileTab === "siparis" ? "#1890ff" : "#f5f5f5",
                                        color: activeMobileTab === "siparis" ? "#fff" : "#666",
                                        border: "1px solid #d9d9d9",
                                        width: "32px",
                                        height: "32px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        borderRadius: "4px 0 0 4px",
                                        cursor: "pointer",
                                        minHeight: "32px",
                                        outline: "none"
                                    }}
                                    onClick={() => setActiveMobileTab("siparis")}
                                >
                                    Sipariş
                                </button>
                                <button
                                    style={{
                                        flex: 1,
                                        background:
                                            activeMobileTab === "detay" ? "#1890ff" : "#f5f5f5",
                                        color: activeMobileTab === "detay" ? "#fff" : "#666",
                                        border: "1px solid #d9d9d9",
                                        borderLeft: "none",
                                        padding: "6px 8px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        borderRadius: "0 4px 4px 0",
                                        cursor: "pointer",
                                        minHeight: "32px",
                                        outline: "none"
                                    }}
                                    onClick={() => setActiveMobileTab("detay")}
                                >
                                    Detay
                                </button>
                            </div>
                            <div style={{maxWidth: "100vw", overflowX: "hidden"}}>
                                {activeMobileTab === "siparis" ? (
                                    <Col xs={24} sm={24} md={16} lg={14} xl={14} xxl={14}>
                                        {renderSiparisCol()}
                                    </Col>
                                ) : (
                                    <Col xs={24} sm={24} md={8} lg={10} xl={10} xxl={10}>
                                        {renderDetayCol()}
                                    </Col>
                                )}
                            </div>
                        </>
                    ) : (
                        <Row gutter={[30, 30]} data-testid="orderDetails">
                            {/* harita ve detaylar */}
                            <Col xs={24} sm={24} md={16} lg={14} xl={14} xxl={14}>
                                {renderSiparisCol()}
                            </Col>
                            {/* sipariş stepleri */}
                            <Col xs={24} sm={24} md={8} lg={10} xl={10} xxl={10}>
                                {renderDetayCol()}
                            </Col>
                        </Row>
                    )}
                    {/* alt butonlar */}
                    <Row
                        justify={isMobile ? "center" : "end"}
                        data-testid="actionButtons"
                        style={{
                            marginTop: "16px"
                        }}
                    >
                        {isMobile ? (
                            // Mobil görünüm - butonları dikey olarak sırala
                            <div style={{width: "100%"}}>
                                {!delivered &&
                                    !canceled &&
                                    !returned &&
                                    stores.meStore.checkPermission("orders.orderActions") &&
                                    ([
                                        "admin",
                                        "oUser",
                                        "superadmin",
                                        "bm",
                                        "agency",
                                        "sy",
                                        "sChef"
                                    ].includes(stores.meStore.role) ||
                                        stores.meStore.subcompanies.some(
                                            subcompany =>
                                                subcompany.subCompanyWorkType === "dedicated"
                                        )) && (
                                        <Button
                                            data-testid="splitButton"
                                            type="primary"
                                            size="large"
                                            block
                                            style={{marginBottom: "8px"}}
                                            onClick={() => {
                                                setHideOrderError(true);
                                                setModalVisible(!modalVisible);
                                                setModalType("splitOrder");
                                                setModalData({deliveryId, orderSteps});
                                            }}
                                        >
                                            {t("actions.splitOrder", {ns: "orderDetail"})}
                                        </Button>
                                    )}
                                {stores.meStore.checkRole("transferOrder") &&
                                    !delivered &&
                                    !canceled &&
                                    !returned && (
                                        <Button
                                            type="primary"
                                            data-testid="transferButton"
                                            size="large"
                                            block
                                            style={{marginBottom: "8px"}}
                                            onClick={() => {
                                                setModalVisible(!modalVisible);
                                                setModalType("transfer");
                                            }}
                                            icon={<CloseCircleOutlined />}
                                        >
                                            {t("actions.transferOrder", {ns: "orderDetail"})}
                                        </Button>
                                    )}
                                {stores.meStore.checkRole("cancelRepeatOrder") &&
                                    stores.meStore.checkPermission("orders.orderActions") &&
                                    !delivered &&
                                    !canceled &&
                                    !returned && (
                                        <Button
                                            type="danger"
                                            data-testid="cancelButton"
                                            size="large"
                                            block
                                            style={{marginBottom: "8px"}}
                                            onClick={() => {
                                                setModalVisible(!modalVisible);
                                                setModalType("cancel");
                                                setModalData({
                                                    deliveryId,
                                                    orderId: text._id
                                                });
                                            }}
                                            icon={<CloseCircleOutlined />}
                                        >
                                            {t("actions.cancelOrder", {ns: "common"})}
                                        </Button>
                                    )}
                                {stores.meStore.checkRole("cancelRepeatOrder") &&
                                    stores.meStore.checkPermission("orders.orderActions") &&
                                    (delivered || canceled || returned) && (
                                        <Button
                                            type="primary"
                                            data-testid="repeatButton"
                                            size="large"
                                            block
                                            style={{marginBottom: "8px"}}
                                            onClick={() => {
                                                history.push(
                                                    "/third-party-request/new/" + deliveryId
                                                );
                                            }}
                                            icon={<UndoOutlined />}
                                        >
                                            {t("actions.resendOrder", {ns: "orderDetail"})}
                                        </Button>
                                    )}
                            </div>
                        ) : (
                            // Desktop görünüm - mevcut tasarım
                            <>
                                {!delivered &&
                                    !canceled &&
                                    !returned &&
                                    stores.meStore.checkPermission("orders.orderActions") &&
                                    (["admin", "oUser", "superadmin", "agency", "sChef"].includes(
                                        stores.meStore.role
                                    ) ||
                                        stores.meStore.subcompanies.some(
                                            subcompany =>
                                                subcompany.subCompanyWorkType === "dedicated"
                                        )) && (
                                        <Row>
                                            <LeftButton
                                                data-testid="splitButton"
                                                type="primary"
                                                onClick={() => {
                                                    setHideOrderError(true);
                                                    setModalVisible(!modalVisible);
                                                    setModalType("splitOrder");
                                                    setModalData({deliveryId, orderSteps});
                                                }}
                                            >
                                                {t("actions.splitOrder", {ns: "orderDetail"})}
                                            </LeftButton>
                                        </Row>
                                    )}
                                {stores.meStore.checkRole("transferOrder") &&
                                    !delivered &&
                                    !canceled &&
                                    !returned && (
                                        <Row>
                                            <MiddleButton
                                                type="primary"
                                                data-testid="transferButton"
                                                onClick={() => {
                                                    setModalVisible(!modalVisible);
                                                    setModalType("transfer");
                                                }}
                                                icon={<CloseCircleOutlined />}
                                            >
                                                {t("actions.transferOrder", {ns: "orderDetail"})}
                                            </MiddleButton>
                                        </Row>
                                    )}
                                {stores.meStore.checkRole("cancelRepeatOrder") &&
                                    stores.meStore.checkPermission("orders.orderActions") &&
                                    !delivered &&
                                    !canceled &&
                                    !returned && (
                                        <Row>
                                            <RightButton
                                                type="danger"
                                                data-testid="cancelButton"
                                                onClick={() => {
                                                    setModalVisible(!modalVisible);
                                                    setModalType("cancel");
                                                    setModalData({
                                                        deliveryId,
                                                        orderId: text._id
                                                    });
                                                }}
                                                icon={<CloseCircleOutlined />}
                                            >
                                                {t("actions.cancelOrder", {ns: "common"})}
                                            </RightButton>
                                        </Row>
                                    )}
                                {stores.meStore.checkRole("cancelRepeatOrder") &&
                                    stores.meStore.checkPermission("orders.orderActions") &&
                                    (delivered || canceled || returned) && (
                                        <Row>
                                            <RightButton
                                                type="primary"
                                                data-testid="repeatButton"
                                                onClick={() => {
                                                    history.push(
                                                        "/third-party-request/new/" + deliveryId
                                                    );
                                                }}
                                                icon={<UndoOutlined />}
                                            >
                                                {t("actions.resendOrder", {ns: "orderDetail"})}
                                            </RightButton>
                                        </Row>
                                    )}
                            </>
                        )}
                    </Row>
                    {/* operasyon notu modal */}
                    <OrderNoteModal
                        visible={orderNoteModalVisible}
                        onClose={() => setOrderNoteModalVisible(false)}
                        onOk={handleOrderNoteSave}
                        order={selectedOrder}
                        operationNotes={operationNotes || []}
                    />
                </React.Fragment>
            )}
        </div>
    );
};
